import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components.
import Select from 'app/client/components/Select';

const CountryField = (props) => {
  const { t } = useTranslation();
  const { options } = props;

  const getLabel = useCallback(
    (data) => t(`core:countries.${data.id?.toLowerCase()}`, data.label),
    [t],
  );

  const sortedOptions = useMemo(
    () =>
      options
        .map((option) => ({ ...option, label: getLabel(option) }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [options, getLabel],
  );

  return (
    <Select
      placeholder={t('core:dataManager.selectCountry')}
      getOptionLabel={getLabel}
      {...props}
      options={sortedOptions}
    />
  );
};

CountryField.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
};

export default CountryField;
